module.exports = __webpack_public_path__ + "img/icon_anonbud_silver.ea5e1699.svg";